/* tslint:disable */
/* eslint-disable */
/**
 * Modulos Platform API v2
 * API for the Modulos Platform.
 *
 * The version of the OpenAPI document: 2.5.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ControlAssessment } from '../model';
// @ts-ignore
import type { ControlAssessmentSummary } from '../model';
// @ts-ignore
import type { HTTPValidationError } from '../model';
/**
 * ControlAssessmentsApi - axios parameter creator
 */
export const ControlAssessmentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Run the control assessment agent and save its result on the control.  The agent assesses the control within this request, so the response carries the assessment as stored — the same record ``GET /api/v1/controls/{id}/assessments`` lists. There is no separate save step: the caller asked for the assessment, so they own it and its AI spend is theirs.  Only processed evidence is assessed; the rest is named in ``evidence_coverage.excluded_evidence``. Answers ``409 Conflict`` when none of the control\'s evidence is processed yet, or while a policy linked to it is still being parsed and indexed.
         * @summary Assess Control
         * @param {string} controlId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assessControl: async (controlId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controlId' is not null or undefined
            assertParamExists('assessControl', 'controlId', controlId)
            const localVarPath = `/controls/{control_id}/assessments`
                .replace('{control_id}', encodeURIComponent(String(controlId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The control\'s most recent assessment with its evidence coverage, or ``null`` when it was never assessed.
         * @summary Get Latest Control Assessment
         * @param {string} controlId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestControlAssessment: async (controlId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controlId' is not null or undefined
            assertParamExists('getLatestControlAssessment', 'controlId', controlId)
            const localVarPath = `/controls/{control_id}/assessments/latest`
                .replace('{control_id}', encodeURIComponent(String(controlId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Coverage and average readiness of a project\'s controls, over each control\'s latest assessment.
         * @summary Get Project Control Assessment Summary
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectControlAssessmentSummary: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getProjectControlAssessmentSummary', 'projectId', projectId)
            const localVarPath = `/controls/assessments/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ControlAssessmentsApi - functional programming interface
 */
export const ControlAssessmentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ControlAssessmentsApiAxiosParamCreator(configuration)
    return {
        /**
         * Run the control assessment agent and save its result on the control.  The agent assesses the control within this request, so the response carries the assessment as stored — the same record ``GET /api/v1/controls/{id}/assessments`` lists. There is no separate save step: the caller asked for the assessment, so they own it and its AI spend is theirs.  Only processed evidence is assessed; the rest is named in ``evidence_coverage.excluded_evidence``. Answers ``409 Conflict`` when none of the control\'s evidence is processed yet, or while a policy linked to it is still being parsed and indexed.
         * @summary Assess Control
         * @param {string} controlId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assessControl(controlId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ControlAssessment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assessControl(controlId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ControlAssessmentsApi.assessControl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The control\'s most recent assessment with its evidence coverage, or ``null`` when it was never assessed.
         * @summary Get Latest Control Assessment
         * @param {string} controlId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestControlAssessment(controlId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ControlAssessment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestControlAssessment(controlId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ControlAssessmentsApi.getLatestControlAssessment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Coverage and average readiness of a project\'s controls, over each control\'s latest assessment.
         * @summary Get Project Control Assessment Summary
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectControlAssessmentSummary(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ControlAssessmentSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectControlAssessmentSummary(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ControlAssessmentsApi.getProjectControlAssessmentSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ControlAssessmentsApi - factory interface
 */
export const ControlAssessmentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ControlAssessmentsApiFp(configuration)
    return {
        /**
         * Run the control assessment agent and save its result on the control.  The agent assesses the control within this request, so the response carries the assessment as stored — the same record ``GET /api/v1/controls/{id}/assessments`` lists. There is no separate save step: the caller asked for the assessment, so they own it and its AI spend is theirs.  Only processed evidence is assessed; the rest is named in ``evidence_coverage.excluded_evidence``. Answers ``409 Conflict`` when none of the control\'s evidence is processed yet, or while a policy linked to it is still being parsed and indexed.
         * @summary Assess Control
         * @param {ControlAssessmentsApiAssessControlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assessControl(requestParameters: ControlAssessmentsApiAssessControlRequest, options?: RawAxiosRequestConfig): AxiosPromise<ControlAssessment> {
            return localVarFp.assessControl(requestParameters.controlId, options).then((request) => request(axios, basePath));
        },
        /**
         * The control\'s most recent assessment with its evidence coverage, or ``null`` when it was never assessed.
         * @summary Get Latest Control Assessment
         * @param {ControlAssessmentsApiGetLatestControlAssessmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestControlAssessment(requestParameters: ControlAssessmentsApiGetLatestControlAssessmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<ControlAssessment> {
            return localVarFp.getLatestControlAssessment(requestParameters.controlId, options).then((request) => request(axios, basePath));
        },
        /**
         * Coverage and average readiness of a project\'s controls, over each control\'s latest assessment.
         * @summary Get Project Control Assessment Summary
         * @param {ControlAssessmentsApiGetProjectControlAssessmentSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectControlAssessmentSummary(requestParameters: ControlAssessmentsApiGetProjectControlAssessmentSummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<ControlAssessmentSummary> {
            return localVarFp.getProjectControlAssessmentSummary(requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for assessControl operation in ControlAssessmentsApi.
 */
export interface ControlAssessmentsApiAssessControlRequest {
    readonly controlId: string
}

/**
 * Request parameters for getLatestControlAssessment operation in ControlAssessmentsApi.
 */
export interface ControlAssessmentsApiGetLatestControlAssessmentRequest {
    readonly controlId: string
}

/**
 * Request parameters for getProjectControlAssessmentSummary operation in ControlAssessmentsApi.
 */
export interface ControlAssessmentsApiGetProjectControlAssessmentSummaryRequest {
    readonly projectId: string
}

/**
 * ControlAssessmentsApi - object-oriented interface
 */
export class ControlAssessmentsApi extends BaseAPI {
    /**
     * Run the control assessment agent and save its result on the control.  The agent assesses the control within this request, so the response carries the assessment as stored — the same record ``GET /api/v1/controls/{id}/assessments`` lists. There is no separate save step: the caller asked for the assessment, so they own it and its AI spend is theirs.  Only processed evidence is assessed; the rest is named in ``evidence_coverage.excluded_evidence``. Answers ``409 Conflict`` when none of the control\'s evidence is processed yet, or while a policy linked to it is still being parsed and indexed.
     * @summary Assess Control
     * @param {ControlAssessmentsApiAssessControlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assessControl(requestParameters: ControlAssessmentsApiAssessControlRequest, options?: RawAxiosRequestConfig) {
        return ControlAssessmentsApiFp(this.configuration).assessControl(requestParameters.controlId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The control\'s most recent assessment with its evidence coverage, or ``null`` when it was never assessed.
     * @summary Get Latest Control Assessment
     * @param {ControlAssessmentsApiGetLatestControlAssessmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getLatestControlAssessment(requestParameters: ControlAssessmentsApiGetLatestControlAssessmentRequest, options?: RawAxiosRequestConfig) {
        return ControlAssessmentsApiFp(this.configuration).getLatestControlAssessment(requestParameters.controlId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Coverage and average readiness of a project\'s controls, over each control\'s latest assessment.
     * @summary Get Project Control Assessment Summary
     * @param {ControlAssessmentsApiGetProjectControlAssessmentSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProjectControlAssessmentSummary(requestParameters: ControlAssessmentsApiGetProjectControlAssessmentSummaryRequest, options?: RawAxiosRequestConfig) {
        return ControlAssessmentsApiFp(this.configuration).getProjectControlAssessmentSummary(requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }
}

